import React from 'react';
import { Box } from '@mui/material';
import { NAV_ITEMS } from '../data/siteContent';
import useScrollSpy from '../hooks/useScrollSpy';
import Seo from './Seo';
import Navbar from './sections/Navbar';
import Hero from './sections/Hero';
import About from './sections/About';
import Solutions from './sections/Solutions';
import ErpHighlight from './sections/ErpHighlight';
import Clients from './sections/Clients';
import Facts from './sections/Facts';
import Contact from './sections/Contact';
import Footer from './sections/Footer';

const SECTION_IDS = NAV_ITEMS.map((item) => item.id);

const CompanyWebsite = () => {
  const activeSection = useScrollSpy(SECTION_IDS, 'home');

  return (
    <>
      <Seo
        title="SSIPL | Enterprise ERP, POS & HR Software in Sri Lanka"
        description="Software Systems International (Pvt) Ltd builds enterprise ERP, POS, inventory, HR and visitor management software for Sri Lankan businesses. Trusted by 190+ cooperative supermarkets and 35+ corporates since 2000."
        path="/"
      />

      {/* Skip link: first thing a keyboard or screen reader user reaches. */}
      <Box
        component="a"
        href="#home"
        sx={{
          position: 'absolute',
          left: 8,
          top: -100,
          zIndex: 15000,
          px: 2.5,
          py: 1.5,
          borderRadius: 2,
          fontWeight: 700,
          backgroundColor: 'primary.main',
          color: 'primary.contrastText',
          textDecoration: 'none',
          transition: 'top 0.2s ease',
          '&:focus': { top: 8 }
        }}
      >
        Skip to content
      </Box>

      <Navbar activeSection={activeSection} />

      <Hero />
      <About />
      <Solutions />
      <ErpHighlight />
      <Clients />
      <Facts />
      <Contact />
      <Footer />
    </>
  );
};

export default CompanyWebsite;
